import userApi from '@/api/user'

const user={
  namespaced:true,
  state:{
    data:[],
    pagination:{current:1,total:0,pageSize:10,showSizeChanger:true,showTotal:total=>`总计 ${total} 条`},
    loading:false,
    editUser:{},
    roles:[],
    sorter:{},
    schools:[],
    baseinfos:[]
  },
  mutations:{
    setData:(state,data)=>{
      state.data=data
    },
    setPagination:(state,pagination)=>{
      state.pagination=pagination
    },
    setLoading:(state,loading)=>{
      state.loading=loading
    },
    edit:(state,user)=>{
      state.disabled=false
      state.editUser=user
    },
    setRoles:(state,roles)=>{
      state.roles=roles
    },
    setSorter:(state,sorter)=>{
      state.sorter=sorter
    },
    setBaseInfos:(state,infos)=>{
      state.baseinfos=infos
    },
    setSchools:(state,schools)=>{
      state.schools=schools
    }
  },
  actions:{
    async GetAll({ commit,state },pagination){
      commit('setLoading',true)
      const page={
        skipCount:pagination.pageSize*(pagination.current-1),
        maxResultCount:pagination.pageSize,
        ...pagination
      }           
      if(state.sorter.field){
        if(state.sorter.order==='ascend'){
          page.sorting=state.sorter.field
        }else{
          page.sorting=state.sorter.field+' desc'
        }
      }
      try{
        const res=await userApi.getAll(page)
        pagination.total=res.result.totalCount
        commit('setPagination',pagination)
        commit('setData',res.result.items)
      }finally {
        commit('setLoading',false)
      }
    },
    async UpdateOrAdd({ commit,dispatch,state },user){
      try{
        if(user.id){
          await userApi.update(user)          
        }else{
          await userApi.create(user)
        }
        commit('edit',{})
        await dispatch('GetAll',state.pagination)
      }catch(err){
        throw err
      }
     
    },
    async GetRoles({ commit }){
      const res= await userApi.getRoles()
      commit('setRoles',res.result.items)
    },
    async ChangePassword(content,input){
      console.dir(content)
      await userApi.changePassword(input)
    },
    async ResetPassword(content,input){
      console.dir(content)
      await userApi.resetPassword(input)
    },
    async Disabled({dispatch,state},user){
      await userApi.disabled({id:user.id})
      await dispatch('GetAll',state.pagination)
    },
    async Active({dispatch,state},user){
      await userApi.active({id:user.id})
      await dispatch('GetAll',state.pagination)
    },
    async GetBaseInfos({ commit },where){
      const res=await userApi.getBaseInfos(where)
      commit('setBaseInfos',res.result.items)
    },
    async GetSchools({ commit }){
      const res=await userApi.getSchools()
      commit('setSchools',res.result.items)
    }
  }
}
export default user